import { GridReadyEvent } from 'ag-grid-enterprise';
import { mapSubqueryToFilterModel } from './filters/mapSubqueryToFilterModel';
import { getInventoryGridApi } from './inventoryGridAPI';
import { getServerSideDatasource } from './serverSideDataSource';
import {
  FetchNextRowsBatchFunction,
  InventoryCommands,
  InventoryContext,
  InventoryDatasourceSelection,
} from './types';

export const initializeInventoryAgGrid = (
  { api }: GridReadyEvent,
  inventoryContext: InventoryContext,
  datasourceSelection: InventoryDatasourceSelection,
  commands: InventoryCommands,
  getNextRowsBatch: FetchNextRowsBatchFunction
) => {
  api.setGridOption('context', inventoryContext);

  // Apply filters before setting datasource to prevent initial request without filters
  if (
    datasourceSelection.dataSourceType === 'workspace' ||
    datasourceSelection.dataSourceType === 'componentType'
  ) {
    const filtersInQueryFormat = datasourceSelection.initialSubquery;
    const filtersInAgGridFormat =
      mapSubqueryToFilterModel(filtersInQueryFormat);
    api.setFilterModel(filtersInAgGridFormat);
  }

  // Set datasource after filters are applied - this triggers getRows with filters already set
  const datasource = getServerSideDatasource(getNextRowsBatch);
  api.setGridOption('serverSideDatasource', datasource);

  commands.registerInventoryGridApi(getInventoryGridApi(api));
};
